
import { Component, Vue, Prop } from "vue-property-decorator";
import ScrollAnimatedTitle from "@/components/ScrollAnimatedTitle.vue";
import ViewportFrameAnimation from "@/components/ViewportFrameAnimation.vue";

@Component({ components: { ScrollAnimatedTitle, ViewportFrameAnimation } })
export default class Contact extends Vue {
  // Kept so the parent Slide's v-bind:progress contract stays satisfied.
  @Prop({ required: false, type: Number, default: 0 })
  private progress!: number;
}
